/* eslint-disable no-param-reassign */
/* eslint-disable object-curly-spacing */
import Vue from "vue";
// axios
import axios from "axios";
// eslint-disable-next-line import/no-cycle
import store from "@/store";
// eslint-disable-next-line import/no-cycle
import useJwt from "@/auth/jwt/useJwt";

// Create a new instance of axios
const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  baseURL: process.env.VUE_APP_BASE_API,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

// Request interceptors
axiosIns.interceptors.request.use(
  (config) => {
    // Auto-derive ActionPrivilegies from URL: /.../{Controller}/{Action} → "Controller-Action"
    const pathname = config.url.split("?")[0];
    const parts = pathname.split("/").filter(Boolean);
    if (parts.length >= 2) {
      config.headers.ActionPrivilegies = `${parts[parts.length - 2]}-${
        parts[parts.length - 1]
      }`;
    }

    config.headers.MerchantId = JSON.parse(
      localStorage.getItem("defaultMerchantId"),
    );
    return config;
  },
  (error) => Promise.reject(error),
);

// Response interceptors
axiosIns.interceptors.response.use(
  (response) => response.data,
  (error) => {
    const status = error.response?.status;
    const url = error.config?.url ?? "";
    if (status === 401) {
      localStorage.removeItem("defaultMerchantId");
      window.location.href = "/login";
    }
    return Promise.reject(error.response);
  },
);

Vue.prototype.$http = axiosIns;

export default axiosIns;
